// Dependencies
import { format } from 'date-fns';
import * as locales from 'date-fns/locale';
import i18next from 'i18next';
import React, { FC, ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// Icons
import Close from '@mui/icons-material/Close';
// Actions
import { updateStocksCurrentDay } from './redux/reducer';
// Types
import { AppState } from '../../reducers';

const ChannelManagerStockCurrentDay: FC = (): ReactElement => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const locales_cpy: { [key: string]: any } = locales;
    const contract_selected = useSelector(
        (state: AppState) => state.channelManager.contract_selected
    );
    const date_criteria = useSelector(
        (state: AppState) => state.channelManager.date_criteria
    );
    const stocks_current_day = useSelector(
        (state: AppState) => state.channelManager.stocks_current_day
    );
    const onStartDateChange = (date: Date | null) => {
        date === null
            ? dispatch(updateStocksCurrentDay(date))
            : (date?.getDay() || date?.getDay() === 0) && dispatch(updateStocksCurrentDay(date));
    };
    useEffect(() => {
        if (stocks_current_day !== null) {
            const container = document.getElementById(
                'manual-accommodation-stocks'
            );
            const day = document.getElementById(
                `manual-accommodation-stocks-date-${format(
                    stocks_current_day,
                    'D-yyyy',
                    { useAdditionalDayOfYearTokens: true }
                )}`
            );
            const name = document.getElementById(
                'manual-accommodation-stocks-name'
            );
            if (container !== null && day !== null && name !== null) {
                container.scrollLeft = day.offsetLeft - name.offsetWidth;
            }
        }
    }, [stocks_current_day]);
    return (
        <FormControl fullWidth>
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={locales_cpy[i18next.language.replace("-", "")]}
            >
                <DatePicker
                    label={t('shared.stock-status-start-date')}
                    value={stocks_current_day}
                    openTo={'month'}
                    defaultCalendarMonth={date_criteria?.start_date || undefined}
                    views={['year', 'month', 'day']}
                    minDate={date_criteria?.start_date || undefined}
                    maxDate={date_criteria?.end_date || undefined}
                    onChange={onStartDateChange}
                    InputProps={{
                        startAdornment: (
                            <IconButton
                                onClick={() => onStartDateChange(null)}
                                style={{ order: 1 }}
                            >
                                <Close />
                            </IconButton>
                        )
                    }}
                    InputAdornmentProps={{
                        position: 'end',
                        style: { order: 2, marginLeft: 0 }
                    }}
                    renderInput={(params) => (
                        <TextField {...params} fullWidth />
                    )}
                />
            </LocalizationProvider>
        </FormControl>
    );
};

export default ChannelManagerStockCurrentDay;
